import {IPrepExtensionsSiteSettings} from '../../../../../../settings/types/ISiteSettingsForSiteAdmin';
import { IResult } from '../../../../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../../../../httpClient/serverApi/requests/Request';

export interface IGetPrepExtensionsSiteSettingsParams {}

export type IGetPrepExtensionsSiteSettingsResult = IResult & IPrepExtensionsSiteSettings;

export class GetPrepExtensionsSiteSettingsRequest extends Request<IGetPrepExtensionsSiteSettingsParams, IGetPrepExtensionsSiteSettingsResult> {
  constructor(params: IGetPrepExtensionsSiteSettingsParams) {
    super('getPrepExtensionsSiteSettings', params);
  }
}
